import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@lightspeed/flame/Core';

import Barcode from '~/renderer/components/Barcode';

import { ReceiptBarcodeWrapper } from './Receipt.style';

interface Props {
  isCompleted: boolean;
  ticketNumber: number | null;
  firstName?: string;
}

const ReceiptGuestBarcode: React.FunctionComponent<Props> = ({
  isCompleted,
  ticketNumber,
  firstName,
}) => {
  const { t } = useTranslation();

  return isCompleted ? (
    <ReceiptBarcodeWrapper>
      <Box as="p" mb={1} mt={0}>
        {t('receipt.paymentSuccessful')},{' '}
        {firstName
          ? t('receipt.seeYouNextTimeName', { name: firstName })
          : t('receipt.seeYouNextTime')}
      </Box>
      {ticketNumber ? <Barcode value={String(ticketNumber)} /> : null}
    </ReceiptBarcodeWrapper>
  ) : null;
};

export default ReceiptGuestBarcode;
